export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Collapse.vue?vue&type=template&id=3d4c39a8&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapse.vue?vue&type=template&id=3d4c39a8&scoped=true
// module id = 1444
// module chunks = 31